import { Link } from 'react-router-dom';

export default function DistributorsShowcase() {
  const distributors = [
    { name: 'Siemens', category: 'Automation, Building Systems & Infrastructure' },
    { name: 'ABB', category: 'Electrification, Automation & VFD Systems' },
    { name: 'Honeywell', category: 'Building Automation & Industrial Controls' },
    { name: 'Parker Hannifin', category: 'Hydraulics, Pneumatics & Valves' },
    { name: 'Carrier', category: 'Commercial HVAC & Refrigeration' },
    { name: 'Trane', category: 'Commercial & Industrial HVAC Systems' },
    { name: 'York', category: 'Commercial Air Conditioning Systems' },
    { name: 'Johnson Controls', category: 'Building Automation & Energy Management' },
    { name: 'Emerson (ASCO / Fisher)', category: 'Solenoid Valves & Flow Control' },
    { name: 'Watts', category: 'Water Safety & Flow Control Products' },
    { name: 'WIKA', category: 'Pressure, Temperature & Level Measurement' },
    { name: 'Belimo', category: 'HVAC Actuators & Control Valves' },
    { name: 'Armstrong Pumps', category: 'HVAC & Industrial Pumping Systems' },
    { name: 'Taco', category: 'Hydronic Pumps & HVAC Components' },
    { name: 'Allis-Chalmers (ITT)', category: 'Industrial Pumping Applications' },
    { name: 'Spirax Sarco', category: 'Steam & Thermal Energy Management' },
    { name: 'Regal Rexnord', category: 'Motors, Blowers & Motion Control' },
    { name: 'McQuay International (Daikin)', category: 'Commercial HVAC Systems' }
  ];

  return (
    <section className="bg-white py-16 md:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <span className="text-[#0D1B3E] text-xs md:text-sm font-semibold tracking-[0.15em] uppercase">
            OUR PARTNERS
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0D1B3E] mt-4 md:mt-6 mb-6 md:mb-8">
            Trusted Distributor Network
          </h2>
          <p className="text-base md:text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto px-4">
            We've established strong partnerships with industry-leading manufacturers and distributors to bring you the highest quality equipment and components. Our extensive network ensures reliable access to the products you need, when you need them.
          </p>
        </div>

        {/* Distributors Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {distributors.map((distributor, index) => (
            <div
              key={index}
              className="bg-[#F8F9FA] rounded-2xl p-6 md:p-8 border border-gray-200 hover:border-[#0066FF] hover:shadow-lg transition-all duration-300 group cursor-pointer"
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gradient-to-br from-[#0D1B3E] to-[#0066FF] flex items-center justify-center flex-shrink-0">
                  <i className="ri-building-line text-lg md:text-xl text-white"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-base md:text-lg font-semibold text-[#0D1B3E] mb-2 group-hover:text-[#0066FF] transition-colors duration-300">
                    {distributor.name}
                  </h3>
                  <p className="text-xs md:text-sm text-gray-600">
                    {distributor.category}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* All Distributors Button */}
        <div className="text-center mt-12 md:mt-16">
          <Link
            to="/distributors"
            className="inline-flex items-center bg-[#0066FF] text-white px-6 md:px-8 py-3 md:py-4 rounded-xl font-semibold hover:bg-[#0052CC] transition-all duration-300 whitespace-nowrap text-sm md:text-base"
          >
            View All Partners
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <p className="text-sm md:text-base text-gray-600 mt-4 px-4">
            And many more trusted partners across Hawaii and the Pacific region
          </p>
        </div>
      </div>
    </section>
  );
}
